import React from 'react';
import moment from 'moment';
import classNames from 'classnames';

import DatePicker from './DatePicker';
import { FormattedMessage } from '../../../utils/i18n';
import Nullable from '@/types/nullable';
import Locale from '@/types/locale';

type Props = {
  startDate: Nullable<Date>;
  endDate: Date;
  maxDate: Date;
  onChange: (startDate: Nullable<Date>, endDate: Date) => void;
  dark?: boolean;
  className?: string;
  locale?: Locale;
  readOnly?: boolean;
};

const DateRangeSelect = ({ startDate, endDate, maxDate, onChange = () => {}, dark, className, locale, readOnly }: Props) => {
  const onStartDateChange = (newDate: Date) => {
    onChange(newDate, endDate);
  };

  const onEndDateChange = (newDate: Date) => {
    onChange(startDate, newDate);
  };

  return (
    <div className={classNames(className, 'date-range-select no-shrink')}>
      <label>
        <FormattedMessage id="Charts.Growth.Dates.From" locale={locale} />
      </label>

      <DatePicker
        compact
        dark={dark}
        invert
        maxDate={moment(maxDate).subtract(1, 'month').toDate()}
        minDetail="year"
        maxDetail="year"
        onDateChange={onStartDateChange}
        defaultDate={startDate}
        locale={locale}
        disabled={readOnly}
      />

      <label>
        <FormattedMessage id="Charts.Growth.Dates.To" locale={locale} />
      </label>

      <DatePicker
        compact
        dark={dark}
        invert
        minDate={startDate ? moment(startDate).add(1, 'month').toDate() : null}
        maxDate={maxDate}
        minDetail="year"
        maxDetail="year"
        onDateChange={onEndDateChange}
        defaultDate={endDate}
        locale={locale}
        disabled={readOnly}
      />
    </div>
  );
};

export default DateRangeSelect;
